import { render } from "./SettingsBanner.vue?vue&type=template&id=78a1b47c"
import script from "./SettingsBanner.vue?vue&type=script&lang=js"
export * from "./SettingsBanner.vue?vue&type=script&lang=js"
script.render = render

export default script